import Api from "../api/api";

export default async ({ id, message }) => {
  const { data } = await Api.post(`report/${id}`, { message });
  return data;
};
